import { render, staticRenderFns } from "./StaticImage.vue?vue&type=template&id=b8ca50de&scoped=true&"
import script from "./StaticImage.vue?vue&type=script&lang=js&"
export * from "./StaticImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8ca50de",
  null
  
)

export default component.exports